import { Box, Divider, Grid, styled, Typography } from '@mui/material';
import { pxToRem } from '@themes';
var StyledChangesContainer = styled(Box)(function (_ref) {
  var theme = _ref.theme;
  var styles = {
    backgroundColor: theme.colors.whisper
  };
  return styles;
});
var StyledChange = styled(Grid)(function (_ref2) {
  var theme = _ref2.theme;
  var styles = {
    backgroundColor: theme.colors.white
  };
  return styles;
});
var StyledListTypographyContainer = styled(Box)(function (_ref3) {
  var theme = _ref3.theme;
  var styles = {
    borderBottom: "".concat(pxToRem(1), " solid ").concat(theme.colors.whisper)
  };
  return styles;
});
var StyledButtonsContainer = styled(Box)(function (_ref4) {
  var theme = _ref4.theme;
  var styles = {
    borderLeft: "".concat(pxToRem(1), " solid ").concat(theme.colors.whisper)
  };
  return styles;
});
var StyledDivider = styled(Divider)(function (_ref5) {
  var theme = _ref5.theme;
  var styles = {
    color: theme.colors.whisper
  };
  return styles;
});
var StyledNewListChanges = styled(Box)(function (_ref6) {
  var theme = _ref6.theme;
  var styles = {
    borderBottom: "".concat(pxToRem(1), " solid ").concat(theme.colors.whisper),
    padding: theme.spacing(4.375, 5),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  };
  return styles;
});
var StyledTypography = styled(Typography, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'highlighted';
  }
})(function (_ref7) {
  var theme = _ref7.theme,
      highlighted = _ref7.highlighted;
  var styles = {
    backgroundColor: highlighted ? theme.colors.grandis : 'unset',
    padding: highlighted ? theme.spacing(0.25) : 'unset'
  };
  return styles;
});
export { StyledButtonsContainer, StyledChange, StyledChangesContainer, StyledDivider, StyledListTypographyContainer, StyledNewListChanges, StyledTypography };